import {
  Box,
  Button,
  Card,
  DialogActions,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Log, getPendingBusinessEntity, getPendingEntityDetails } from "../../services/services";
import ListHead from "../table/ListHead";
import Scrollbar from "../table/Scrollbar";
import RejectPendingEntity from "./Dialogs/RejectPendingEntity";
import { PendingEntityAction } from "../../services/services";
import { applySortFilter } from "../../utils/tableFunctions";
import { StyledTableRow } from "../TableRow";
import EntityDetails from "../../pages/details/entity/EntityDetails"
import { useLoadingSpinnerContext } from "../../context/loadingSpinnerContext";
import { CustomTableCell } from "../TableCell";
import CommonDialog from "../CustomDialog";
import CircularLoader from "../circularLoader";
import { styles } from "../../utils/styles";
import { pageNumber, rowsPerPage } from "../../utils/constants";
import Pagination from "../Pagination";

const TABLE_HEAD = [
  { id: "business_name", label: "Business Name" },
  { id: "action", label: "Action" },
  { id: "details" },
];

const PendingEntity = ({ userRole }) => {
  const { setGlobalLoading } = useLoadingSpinnerContext();
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [entityList, setEntityList] = useState({ results: [], count: 0 });
  const [loaded, setLoaded] = useState(false);
  const [pagination, setPagination] = useState({
    page: pageNumber,
    page_size: rowsPerPage,
  });

  // dialogs
  const [openRejectDialog, setOpenRejectDialog] = useState(false);
  const [selectedId, setSelectedId] = useState();
  const [pendingDetails, setPendingDetails] = useState(null);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const filteredList = applySortFilter(
    entityList.results || [],
    order,
    orderBy
  );

  const isItemNotFound = filteredList.length === 0;

  const queryPage = (queryParams) => {
    setLoaded(false);
    getPendingBusinessEntity(
      (res) => {
        setEntityList(res);
      },
      setLoaded,
      queryParams
    );
    setPagination(queryParams);
  };

  const handleChangePage = (event, newPage) => {
    queryPage({
      page: newPage + 1,
      page_size: pagination.page_size,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    queryPage({
      page: 1,
      page_size: event.target.value,
    });
  };

  useEffect(() => {
    queryPage(pagination);
  }, []);

  const handleCloseDialog = (shouldResetDetails) => {
    setOpenRejectDialog(false);
    if (shouldResetDetails === true) setPendingDetails(null);
  };

  return (
    <Box>
      {loaded ? 
        <Card>
          <Scrollbar>
            <TableContainer>
              <Table>
                <ListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  onRequestSort={handleRequestSort}
                  checkbox={false}
                />

                <TableBody>
                  {filteredList.map((row) => {
                        const { id, business_name, action } = row;

                        return (
                          <StyledTableRow
                            hover
                            key={id}
                          >
                            <CustomTableCell field={business_name ? business_name.toUpperCase() : ""} />
                            <CustomTableCell field={action} />
                            <TableCell>
                              <Button
                                variant="text"
                                color="secondary"
                                onClick={() => {
                                  setGlobalLoading(true);
                                  getPendingEntityDetails(id, setPendingDetails, () => setGlobalLoading(false)
                                  );
                                }}
                              >
                                View Detail
                              </Button>
                            </TableCell>
                          </StyledTableRow>
                        );
                      })}
                </TableBody>
                {isItemNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper>
                          <Typography
                            gutterBottom
                            align="center"
                            variant="subtitle1"
                          >
                            There are no pending business entities at the moment.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
          {!isItemNotFound && (
            <Pagination
              count={entityList.count}
              pagination={pagination}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </Card>
        :
        <CircularLoader />
      }
      {selectedId && (
        <RejectPendingEntity
          open={openRejectDialog}
          onClose={handleCloseDialog}
          id={selectedId}
          setEntityList={(res) => setEntityList(res)}
          setLoaded={setLoaded}
        />
      )}

      {pendingDetails && (
        <CommonDialog
          title="Business Entity Details"
          onClose={() => setPendingDetails(null)}
          renderActions={() =>
            userRole.includes("Approve/Reject") && (
              <DialogActions>
                <Button
                  variant="outlined"
                  // color="inherit"
                  onClick={() => {
                    setOpenRejectDialog(true);
                    setSelectedId(pendingDetails.id);
                  }}
                >
                  Reject
                </Button>
                <Button
                  variant="contained"
                  onClick={async () => {
                    setGlobalLoading(true);
                    Log.info(
                      `Click button [Approve] - Approve Business Entity by Id: ${pendingDetails.id}`
                    );
                    await PendingEntityAction(
                      pendingDetails.id,
                      "approve",
                      (res) => setEntityList(res),
                      setLoaded
                    );
                    setPendingDetails(null);
                    setGlobalLoading(false);
                  }}
                  sx={{ ...styles.customButton }}
                >
                  Approve
                </Button>
              </DialogActions>
            )
          }
        >
          <EntityDetails detailsData={pendingDetails} />
        </CommonDialog>
      )}
    </Box>
  );
};

export default PendingEntity;
